export enum TimeInterval {
  MONTH = 'Måned',
  QUARTER = 'Kvartal',
  YEAR = 'År',
}

export type BudgetGroupBy = 'none' | 'kontoklasse' | 'distributionGroup'

export enum AdditionalRows {
  CURRENT_ACCOUNTING = 'Regnskap hittil',
  CURRENT_BUDGET = 'Budsjett',
  ACCOUNTS_PREVIOUS_YEAR = 'Regnskap forrige år',
}
